import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { Grid, useMediaQuery } from '@mui/material';

import PropertyCard from './PropertyCard';
import { useRef } from 'react';

// components/PropertyCarousel.tsx





export enum PropertyType {
    CABIN = "cabin",
    HOUSE = "house",
    MOBILE_HOUSE = "mobile_house",
    COTTAGE = "cottage",
    FAMILY_HOUSE = "family_house",
    HOTEL = "hotel",
    COUNTRY_HOUSE = "country_house",
    BUILDING = "building",
    GARDEN_HOUSE = "garden_house",
    LOG_HOUSE = "log_house",
    VILLA = "villa",
    OTHER = "other",
}

// const properties = Array(15).fill(0).map((_, i) => ({
//     id: i,
//     title: 'PEKNÝ 4 IZBOVÝ ZREKONŠTRUOVANÝ RD',
//     location: 'Hejce, Maďarsko',
//     type: 'Rodinný dom',
//     size: '140 m²',
//     price: '79 900 €',
//     tags: ['Rodinný dom', '4 izby', '140 m²'],
//     imageUrl: 'https://storage.googleapis.com/reality-aandt/67fcd1fea3886e35e97f5189/1.jpg', // Replace with actual image path or URL
// }));


type PropertyCarouselProps = {
    title: string;
    description?: string
    sortBy?: 'newest' | 'oldest'
    filter?: {
        propertyType?: PropertyType[]
        notPropertyType?: PropertyType[]
        price?: {
            min?: number
            max?: number
        }
    }
    properties: any[]
    id?: string
}

const applySorting = (properties: any[], sortBy: 'newest' | 'oldest') => {
    if (sortBy === 'newest') {
        return properties.sort((a, b) => new Date(b.listedDate).getTime() - new Date(a.listedDate).getTime());
    } else {
        return properties.sort((a, b) => new Date(a.listedDate).getTime() - new Date(b.listedDate).getTime());
    }
}

const applyFiltering = (properties: any[], filter: PropertyCarouselProps['filter']) => {
    if (!filter) return properties;
    return properties.filter((property) => {
        if (filter.propertyType && !filter.propertyType.includes(property.propertyType as PropertyType)) return false;
        if (filter.notPropertyType && filter.notPropertyType.includes(property.propertyType as PropertyType)) return false;
        if (filter.price && filter.price.min && filter.price.max && (property.price < filter.price.min || property.price > filter.price.max)) return false;
        return true;
    });
}

export default function PropertyCarousel({ title, description, sortBy, filter, properties, id }: PropertyCarouselProps) {
    const scrollRef = useRef<HTMLDivElement>(null);
    const isMobile = useMediaQuery('(max-width: 768px)');


    const scroll = (direction: 'left' | 'right') => {
        if (!scrollRef.current) return;
        const scrollAmount = window.innerWidth; // px to scroll per click
        scrollRef.current.scrollBy({
            left: direction === 'left' ? -scrollAmount : scrollAmount,
            behavior: 'smooth',
        });
    };

        // let interval: NodeJS.Timeout | null = setInterval(() => {
        //     scroll('right');
        // }, 2000);
        // useEffect(() => {
        //     interval = setInterval(() => {
        //         scroll('right');
        //     }, 2000);
        //     return () => clearInterval(interval as NodeJS.Timeout);
        // }, []);

    // const allPropertyTypes = properties.map((property) => property.propertyType);
    // const uniquePropertyTypes = [...new Set(allPropertyTypes)];
    // console.log(allPropertyTypes);

    const sortedProperties = applySorting(properties || [], sortBy || 'newest');
    const filteredProperties = applyFiltering(sortedProperties, filter);

    return (
        <div className={"relative px-5"} style={{ marginTop: isMobile ? '1rem' : '2rem', }} id={id}>
            <Grid container> 
                <Grid  size={{xs: 12, sm: 9 }}>
                <h2 className="text-3xl font-bold text-[#9b8b4b]" style={{ fontSize: '2rem', color: '#9b8b4b', margin: 0 }}>{title}</h2>
                <p className="text-gray-600 mt-1" style={{ fontWeight: '500', fontSize: '1.2rem', margin: 0 }}>
                    {description}
                    {/* Najnovšie pridané nehnuteľnosti – možnosť byť medzi prvými záujemcami. */}
                </p>
                </Grid>

                <Grid  size={{xs: 12, sm: 3 }}>
                <div className="flex justify-end mt-2 w-full gap-2" style={{  }}>
                    <button
                        onClick={() => scroll('left')}
                        className="p-2 rounded-full arrow-button flex justify-center items-center"
                    >
                        <ArrowLeftIcon />
                    </button>
                    <button
                        onClick={() => scroll('right')}
                        className="p-2 rounded-full arrow-button flex justify-center items-center"
                    >
                        <ArrowRightIcon />
                    </button>
                </div>
                </Grid>
            </Grid>
            

            <div className="relative mt-6 flex flex-row" style={{ position: 'relative', right: 0, top: 0 }}>
               

                <div
                    style={{ display: 'flex', flexDirection: 'row', gap: '1rem', paddingBottom: '3rem', overflowX: 'auto'}}
                    className="scrollbar-hide scroll-smooth scrollbar-hide"
                    ref={scrollRef}
                >
                    {filteredProperties.map(property => (
                        <PropertyCard key={property._id} property={property} />
                    ))}
                </div>

               
            </div>
        </div>
    );
}
